import { render } from "./EditBuybackList.vue?vue&type=template&id=2452b3b5"
import script from "./EditBuybackList.vue?vue&type=script&lang=js"
export * from "./EditBuybackList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/EditBuybackList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2452b3b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2452b3b5', __exports__)) {
    api.reload('2452b3b5', __exports__)
  }
  
  module.hot.accept("./EditBuybackList.vue?vue&type=template&id=2452b3b5", () => {
    api.rerender('2452b3b5', render)
  })

}


export default __exports__